import RUF from "../../../util/redux";

export function modelSetLoanTerm(state, action) {
  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      loanTerm: action.payload
    })
  });
}
